/**
 * Created by caterina on 16-05-17.
 */
export class Folder {
  id: number;
  name: string;
  parent: number;
  owner: string;
}



// WEBPACK FOOTER //
// ./src/app/folder/folder.ts